import {
    UsersIcon,
    CubeIcon,
    TruckIcon,
    BuildingOfficeIcon,
    ClockIcon,
    CheckCircleIcon,
} from '@heroicons/react/24/outline'
import { colorMap } from '../../../Common'

const CardMetricas = ({ dataMetricas, color = 'blue' }) => {
    // Seleciona as classes baseadas na cor fornecida, com fallback para blue
    const colorClasses = colorMap[color] || colorMap.blue

    // Função para mapear ícones baseado no nome
    const getIconByType = (iconType) => {
        switch (iconType) {
            case 'box': return CubeIcon
            case 'truck': return TruckIcon
            case 'users': return UsersIcon
            case 'check-circle': return CheckCircleIcon
            case 'building': return BuildingOfficeIcon
            case 'clock': return ClockIcon
            default: return CubeIcon
        }
    }

    // Mapeamento de cores individuais para classes Tailwind completas
    const getColorClassesByType = (colorType) => {
        const colorMapLocal = {
            blue: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            green: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            orange: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            purple: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            red: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            yellow: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            indigo: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            pink: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            emerald: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            teal: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            },
            cyan: {
                iconBg: 'bg-brand-cyan/20',
                iconText: 'text-brand-cyan-dark'
            }
        }

        return colorMapLocal[colorType] || colorMapLocal.blue
    }


    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8 w-full max-w-full">
            {dataMetricas && dataMetricas.length > 0 && (
                dataMetricas.map((stat, index) => {
                    const IconComponent = getIconByType(stat.icon)
                    // Usa a cor individual da métrica se especificada, senão usa a cor padrão do componente
                    const metricColor = stat.color || color
                    const metricColorClasses = getColorClassesByType(metricColor)

                    return (
                        <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 stats-card dashboard-card animate-fade-in-up w-full max-w-full overflow-hidden" style={{ animationDelay: `${index * 100}ms` }}>
                            <div className="flex items-center justify-between mb-4">
                                <div className={`p-3 rounded-full ${metricColorClasses.iconBg} icon-hover flex-shrink-0`}>
                                    <IconComponent className={`w-6 h-6 ${metricColorClasses.iconText}`} />
                                </div>
                            </div>
                            <div className="min-w-0">
                                <p className="text-2xl font-bold text-gray-900 number-animation truncate">{stat.value}</p>
                                <p className="text-sm font-medium text-gray-600 truncate">{stat.title}</p>
                            </div>
                        </div>
                    )
                })
            )}
        </div>
    )
}



export default CardMetricas